import * as React from "react";
import * as ReactDOM from "react-dom";
import Commonnav from "@/layouts/commonnav/commonnav";
import ZeusZeusZeusPowerCenterDetail from "@/widgets/zeus_zeus_zeus_power_center_detail";
import ZeusZeusZeusPowerCenterDetailData from "./data/zeus_zeus_zeus_power_center_detail/data";

class Home extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Commonnav>
        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div className="jdw-widget" data-name="zeus_zeus_zeus_power_center_detail" data-version="5.0.18">
                <ZeusZeusZeusPowerCenterDetail {...ZeusZeusZeusPowerCenterDetailData} />
              </div>
            </div>
          </div>
        </div>
      </Commonnav>
    );
  }
}

ReactDOM.render(<Home />, document.getElementById("root"));
